module.exports = __webpack_public_path__ + "static/background_header-50aa714630688961415df2a095666f17.png";